interface SaleRecipient {
  customer_id?: string | null;
  customer_name?: string | null;
  customer_mobile?: string | null;
  customer_address?: string | null;
}

/** Edit the saved delivery snapshot; selecting a customer explicitly can populate new details. */
export function saleRecipientFormValues(saved: SaleRecipient) {
  return {
    customer_id: saved.customer_id ?? '',
    customer_name: saved.customer_name ?? '',
    customer_mobile: saved.customer_mobile ?? '',
    customer_address: saved.customer_address ?? '',
  };
}

function editedSnapshot(value: string | null | undefined, saved: string | null | undefined) {
  const clean = value?.trim() || '';
  // Inputs/schema normalize display values. An untouched null, empty or padded snapshot
  // must still be sent exactly as saved, otherwise the post-dispatch guard sees an edit.
  return clean === (saved ?? '').trim() ? (saved ?? null) : clean || null;
}

export function saleRecipientPayload(values: SaleRecipient, saved?: SaleRecipient) {
  if (saved) {
    return {
      customer_id: editedSnapshot(values.customer_id, saved.customer_id),
      customer_name: editedSnapshot(values.customer_name, saved.customer_name),
      customer_mobile: editedSnapshot(values.customer_mobile, saved.customer_mobile),
      customer_address: editedSnapshot(values.customer_address, saved.customer_address),
    };
  }
  // Keep the existing new-sale normalization and intentional customer-selection workflow.
  return {
    customer_id: values.customer_id?.trim() || undefined,
    customer_name: values.customer_name?.trim() || undefined,
    customer_mobile: values.customer_mobile?.trim() || null,
    customer_address: values.customer_address?.trim() || undefined,
  };
}
